import * as cr from "./_cr";
import * as cs from "./_ca";
import * as hf from "./_hf";
import * as ht from "./_ht";

import { useMdlz } from "./_csMdl";
import { a } from "./_csAbt";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as TextC from "./_ccbTextC";

//export const useMdlMsgz = () => {
export const useMsgz = () => {
  const _sMdlz = useMdlz();
//  const _abtType = 'nmlz';
//  const _abtz = cs.mdlMsgAbtz[_abtType] ? cs.mdlMsgAbtz[_abtType]() : {} as ht.dz;
  const _show = (pz: {
    abtType?: ht.s,
    textCz: ht.textCz,
  }) => {
    if (!pz.textCz) hf.l(`useMsgz warning: no textCz`);
    const _dw = cr.d('p') ? 60 : 40;
    _sMdlz.set({
      bShow: true,
      bCls: false,
      oClds: [
        cr.c(BoxC.N, {
          key: -10,
//          boxStlz: _abtz.boxStlz,
          boxStlz: a(`br/1 dw/${_dw} dhx/70 fd/csc p/1 sc/lt1`),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              ... pz.textCz,
              boxStlz: {
//                ... _abtz.textCz.boxStlz,
                ... a("dw/f fd/csc fw/w"),
                ... pz.textCz.boxStlz,
              },
              textz: {
                ... pz.textCz.textz,
                stlz: {
//                  ... _abtz.textCz.textz.stlz,
                  ... a('tc/lt9'),
                  ... pz.textCz.textz.stlz,
                },
                ptyz: {
//                  ... _abtz.textCz.textz.ptyz,
                  ... a("tn/10"),
                  ... pz.textCz.textz.ptyz,
                },
              },
            }),
            cr.c(BoxC.N, {
              key: -20,
//              boxStlz: _abtz.btnz.boxStlz,
              boxStlz: a('dw/f fd/rac mt/2 mb/0.5'),
              oClds: [
                cr.c(BtnC.N, {
                  key: -10,
                  crlz: {
                    abtType: 'rnd30z',
                  },
                  boxStlz: a('br/2 dw/10 fd/ccc sc/lt5'),
                  lblCz: {
                    textz: {
                      pfx: "はい",
                      stlz: a('tb tc/lt1'),
                    },
                  },
                  pslPtyz: {
                    onPress: () => {
                      _sMdlz.set({
                        bShow: false,
                      });
                    },
                  },
                }),
              ]
            })
          ],
        })
      ]
    })
  }

  return {
    show: _show
  }
};

export const useMdlMsgz = useMsgz; // 廃止予定
